import { ChangeEvent, KeyboardEvent, useRef, Dispatch, SetStateAction } from 'react';
import styles from "./CodeInput.module.scss";

type CodeInputProps = {
    code: string;
    setCode: Dispatch<SetStateAction<string>>;
    fields: number;
    onKeyPress?: (event: KeyboardEvent<HTMLInputElement>) => void;
}

const CodeInput = ({ code, setCode, fields, onKeyPress}: CodeInputProps) => {

    const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

    const handleChange = (event: ChangeEvent<HTMLInputElement>, index: number) => {
        const value = event.target.value;
        if (/[^0-9]/.test(value)) return;
        const newCode = code.split('');
        newCode[index] = value;
        setCode(newCode.join(''));
        if (value && index < fields - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>, index: number) => {
        if (event.key === 'Backspace') {
            if (index > 0 && !code[index]) {
                inputRefs.current[index - 1]?.focus();
            }
        } else if (event.key === 'ArrowRight') {
            if (index < fields - 1) {
                inputRefs.current[index + 1]?.focus();
            }
        } else if (event.key === 'ArrowLeft') {
            if (index > 0) {
                inputRefs.current[index - 1]?.focus();
            }
        }
    };

    return (
        <div>
            {Array.from({ length: fields }).map((_, index) => (
                <input
                    key={index}
                    ref={el => (inputRefs.current[index] = el)}
                    type="tel"
                    maxLength={1}
                    value={code[index] || ''}
                    onChange={(event) => handleChange(event, index)}
                    onKeyDown={(event) => handleKeyDown(event, index)}
                    className={styles.inputCode}
                    inputMode="numeric"
                    onKeyDownCapture={onKeyPress}
                />
            ))}
        </div>
    );
};

export default CodeInput;
